<template>
  <el-dialog
    :visible.sync="visible"
    width="1000px"
    @close="$emit('update:show', false)"
    @open="opened()"
    :close-on-click-modal="false"
  >
    <div class="text-center">
      <video
        id="media"
        :src="src"
        controls
        width="900"
        height="600"
        autoplay
      ></video>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.show) {
        let media = document.getElementById('media')
        media.pause()
      }
    },
  },
  data() {
    return {
      visible: this.show,
    }
  },
  methods: {
    opened() {
      // console.log(this.src)
    },
  },
}
</script>